import { boot } from 'quasar/wrappers'
import type { Component } from 'vue'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { PieChart, BarChart, GraphChart } from 'echarts/charts'
import { TitleComponent, TooltipComponent, GridComponent, LegendComponent } from 'echarts/components'
import VChart from 'vue-echarts'

use([CanvasRenderer, PieChart, BarChart, GraphChart, TitleComponent, TooltipComponent, GridComponent, LegendComponent])

export default boot(({ app }) => {
  app.component('VChart', VChart as Component)
})
